import Render from '@Views/root/home/widget-referral.html'
import { Vue, Component } from 'vue-property-decorator'
import { referral, user } from '@Store/modules'

@Render
@Component({})
export class WidgetReferral extends Vue {

	//godchildCount: number = 0

	get code(): string {
		return !!user.currentUser ? user.currentUser.referral_code : ''
	}
	get referralBonusMonths(): number {
		return user.currentUser.referral_count * 3
	}

	get godchildCount(): number {
		return user.currentUser.referral_count;
	}

	mounted() {
	}
}
